import { ResponseCartItemModel } from '../../api/data-contracts';
import { ExtendedOrderResponseModel } from './types';

export * from './types';

export const collapseCartDuplicates = (
  data: ExtendedOrderResponseModel,
): ExtendedOrderResponseModel => ({
  ...data,
  cartItems: Object.values(
    data?.cartItems?.reduce<Record<string, ResponseCartItemModel>>((acc, obj) => {
      if (!acc[obj.id as string]) {
        acc[obj.id as string] = { ...obj };
      } else {
        acc[obj.id as string].count += obj.count;
      }
      return acc;
    }, {}) || {},
  ),
});
